<template>
  <div>
    <h4>
      {{ "subscription_step_1" | setText("1. Номер телефона") }}
      <span v-if="value.phone_control" class="ti-check text-success"></span>
    </h4>

    <p class="mb-4">{{ value.plan }}</p>

    <div class="row">
      <div class="col-12 col-md-12">
        <fg-input
          type="text"
          :label="'Номер по тарифу'"
          :labelKey="'phone_control'"
          v-mask="`+998#########`"
          v-model="data['phone_control']"
          :placeholder="`+998`"
        />
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          type="text"
          :label="'Номер бланка'"
          :labelKey="'blank_number'"
          v-model="data['blank_number']"
        />
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          type="date"
          :label="'Дата бланка'"
          :labelKey="'blank_date'"
          v-model="data['blank_date']"
        />
      </div>
    </div>

    <button v-if="value.state === 'new'" class="btn btn-info mw" @click="apply">
      {{ "apply" | setText("Применить") }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: {
        phone_control: "+998",
        blank_number: null,
        blank_date: null,
      },
    },
  },
  methods: {
    apply() {
      this.$emit("input", this.data);
    },
  },
  data() {
    return {
      data: this.value,
    };
  },
};
</script>